import { PopupAppFieldType } from "src/app/modules/jha-screen/model/Component.model";
import { JSFunctions, JSVariables, Logos } from "../../settings/settings.model";

export interface DocResp {
  status: ResponseStatus;
  message: string;
  title: string;
  resObj: Doc;
  resObjType: string;
  sucess: boolean;
  failed: boolean;
  success: boolean;
  primaryVersion: string;
}

export interface Doc {
  appName: string;
  appDisplayName: string;
  appDecription: string;
  lastModified: Date;
  appType: AppType;
  statusList: StatusList[];
  filePath?: string;
  institutionId?: string;
  defaultFontSize?: string;
  defaultTextAlign?: string;
  defaultItalic: boolean;
  defaultBold: boolean;
  addBorderToInputs: boolean;
  enableNewRecord: boolean;
  disableShareLoanLoanAppPopup: boolean;
  onLoad: string[];
  onSubmit: string[];
  views: View[];
  reload: boolean;
  signerParties: SignerParty[];
  imagingDocType: string;
  imagingDocName: string;
  imagingIndex: ImagingIndex;
  jsFunctions: JSFunctions;
  jsVariables: JSVariables;
  printSetting: PrintSetting;
  barcode?: Barcode;
  logo?: Logos;
  autoPrint: boolean;
  workAreas: string[];
  roles: Role[];
  permission: string;
  emailTemplate: string;
  permissions: string[];
  privilegeGroups: number[];
  catalogs: string[];
  version: number; // This is not the new document version, but the version of ???
  primaryVersion: number; // This is the new document version
  majorVersion: string; // This is the version like "v1" this is what the UI uses
  shortStatus: string;
  lastUpdate: Date;
  defaultFont: string;
}

export enum PopupType {
  FORM = "form",
  TABLE = "table",
}

export enum PopupSize {
  SMALL = "small",
  MEDIUM = "medium",
  LARGE = "large",
}

export enum AppType {
  DOCCONFIG = "DOCCONFIG",
  ESIGN = "ESIGN",
  FORM = "FORM",
  IMAGING = "IMAGING",
  POWERAD = "POWERAD",
  POWERSCREEN = "POWERSCREEN",
  RECEIPT = "RECEIPT",
  CHECK = "CHECK",
  MICROAPP = "MICROAPP",
  SYMPDF = "SYMPDF",
  DOCSET = "DOCSET",
}

export interface StatusList {
  shortStatus: string;
  status: string;
  userFirstLast: string;
  userId: string;
  symId: string;
  symHost: string;
  statusDate: Date;
}

export interface View {
  viewType: ViewType;
  viewName: string;
  viewDisplayName?: string;
  font?: string;
  title?: string;
  width?: string;
  height?: string;
  url?: string;
  headers: AppViewHeader[];
  onLoad: OnHandler;
  onSubmit: OnHandler;
  appFields: { [key: string]: AppField };
  importedServices: ImportedService[];
  silentPrint: boolean;
  orginFormType: string;
  popupDetails?: PopupDetails;
  mirrorGroups?: MirrorGroups;
  pbutton?: string;
  sbutton?: string;
  imagingIndex?: ImagingIndex | Record<string, never>;
  signerParties?: SignerParty | Record<string, never>;
  rtParties?: any[];
}

export type MirrorInputType = "TEXT" | "CHECKBOX" | "RADIOBTN";

export interface MirrorField {
  mirrorFields: string[];
  inputType: MirrorInputType;
}

export interface MirrorGroups {
  [key: string]: MirrorField;
}

export interface PopupDetails {
  data?: PopupFieldData[];
  html?: string;
  popupType?: PopupType;
  stageBackgroundImageSource?: string;
  stageDefaultInfo?: StageDefaultInfo;
  table?: PopupTableDetails;
}

// This is a new structure, old one for columns was called "header" and was not inside popupDetails
// also  old mapkey was store inside Local includedServices
export interface PopupTableDetails {
  mapKey: string;
  columns?: PopupTableColumn[];
}

export interface PopupTableColumn {
  name: string;
  data: string;
}

export interface StageDefaultInfo {
  fontFamily?: string;
  fontSize?: string;
  stageHeight: number;
  stageWidth: number;
  textAlign?: string;
}

export interface PopupFieldData {
  id: string;
  cp_display: string;
  fieldDisplayName: string;
  fontFamily: string;
  fontSize: string;
  fontWeight?: string;
  height: number;
  hidden: boolean;
  icon: string;
  inner_text: string;
  left: number;
  mappedServiceId: number;
  name: string;
  name_for_server: string;
  parentId: number;
  style: string;
  borderStyle?: string;
  src?: string;
  textAlign: string;
  top: number;
  type: string;
  width: number;
  choices?: RadioChoice[];
  options?: string[];
  url?: string;
  size?: number;
  value?: string;
  mappedServiceName?: string;
}

export interface PopupFieldValidation {
  customValidation: string;
  required: boolean;
  standardValidation: string;
}

export interface AppViewHeader {
  headerName: string;
  mappedField: string;
}

export interface SignerParty {
  signerRole: string;
  recordId: string;
  locator: string;
  firstName: string;
  lastName: string;
  fullName: string;
  ssn: string;
  dob: string;
  street: string;
  apartment: string;
  city: string;
  state: string;
  zipCode: string;
  homePhone: string;
  homeEmail: string;
  workEmail: string;
  routeOrder: string;
}

export interface ImagingIndex {
  turnOffIndex?: boolean;
  indexName: string;
  nameSpace: string;
  docmentType: string;
  defaultIndexType?: string;
  indexType: string;
  indexTeamplate?: string;
  vocabulary: string;
  defaultFlag: boolean;
  pdfBase64?: string;
  indexFields: any[];
}

export interface Role {
  institutionId: string;
  workspaceId: string;
  roleId: string;
  description: string;
  instAdminRole: boolean;
}

export interface Permission {
  insitutionId: string;
  role: string;
  product: string;
  service: string;
  operation: string;
}

export interface Barcode {
  name: string;
  type: string;
  text: string;
  altText: string;
  scale: Vector2D;
  options: string;
  data?: string;
  position: Vector2D;
  pageNumber: number;
  pageWidth: number;
  pageHeight: number;
  block?: string;
  itOn: boolean;
  pages?: number[];
}

export interface Vector2D {
  x: number;
  y: number;
}

export interface Position {
  x: number;
  y: number;
}

export interface Service {
  actionType: ActionType;
  serviceGroup: string;
  service: string;
  name: string;
}

export enum ActionType {
  SERVICE = "SERVICE",
  TRIGGER = "TRIGGER",
  FUNCTION = "FUNCTION",
}

export interface PrintSetting {
  name?: string;
  paperSize?: string;
  orientation?: string;
  duplexMode?: string;
  printerName?: string;
  autoPrintToDefault: boolean;
  autoPrint: boolean;
  showPrintDialog: boolean;
  defaultFlag: boolean;
}

export interface AppField {
  name: string;
  displayName: string;
  value: string;
  imageValue?: string;
  printValue: string;
  derived: boolean;
  valueExpression: string;
  type: AppFieldType | PopupAppFieldType;
  pdfFieldName: string;
  pdfFieldType: string;
  readOnly: boolean;
  invisible: boolean;
  maskOnPrint: boolean;
  maskOnImaging: boolean;
  hideOnPrint: boolean;
  fieldDataType: FieldData;
  fieldTriggers?: Trigger | Record<string, never> | Record<string, never>;
  tabOrder: number;
  dependentFields: string[];
  fonts: Fonts | Record<string, never> | Record<string, never>;
  helpLtrChoice: string;
  helpLtrFile: string;
  options: { [key: string]: string }[];
  signatureSequenceNumber: string;
  signInitial: boolean;
  signatureDateField: string;
  signatureData: string;
  signerId: string;
  defaultValue: string;
  defaultListValue: DefaultListValue[];
  filter: Filter;
  signerList: string[];
  mask: { [key in MaskArea]: number } | object | object;
}

export interface Fonts {
  fontFamily: string;
  fontSize: string;
  textAlign: string;
  fontStyle: string;
  fontWeight: string;
}

export enum MaskArea {
  PRINT = "print",
  IMAGING = "imaging",
  VIEW = "view",
}

export enum MaskingOptions {
  ALL = "Mask all",
  ALL_BUT = "Mask all but...",
  NONE = "No mask",
}

export enum MaskingOrder {
  FIRST = "First",
  LAST = "Last",
}

export interface FieldData {
  type: FieldType;
  format: string;
  required: boolean;
  maxLength: number;
  range: Range;
  validator: FieldValidator;
}

export interface Trigger {
  customHandler: string;
  services: Service[];
}

export interface DefaultListValue {
  key: string;
  value: string;
  order: number;
}

export interface Range {
  min: string;
  max: string;
}

export enum FieldType {
  NUMBER = "NUMBER",
  DATE = "DATE",
  STRING = "STRING",
  RATE = "RATE",
  LOGO = "LOGO",
  SIGNATURE = "SIGNATURE",
  SIGNATURE_DATE = "SIGNATURE_DATE",
  ALPHA_NUMERIC = "ALPHA_NUMERIC",
  ALPHA_NUMERIC_SPACES = "ALPHA_NUMERIC_SPACES",
  EMAIL = "EMAIL",
  CODE = "CODE",
  MONEY = "MONEY",
  ALPHA_NUMERIC_SPECIALCHARS = "ALPHA_NUMERIC_SPECIALCHARS",
  TAX_ID = "TAX_ID",
  PHONE = "PHONE",
  ZIP_CODE = "ZIP_CODE",
  IMAGE = "IMAGE",
}

export interface FieldValidator {
  script: string;
  primary: string;
}

export interface Filter {
  code: string;
  expressions: Expression[];
}

export interface Expression {
  id: string;
  operator: string;
  field: string;
  condition: string;
  value: string;
  type: string;
  conditions: string[];
}

export type ImportedServiceType =
  | "NONE"
  | "POWERON"
  | "LOCAL"
  | "IN_BOUND"
  | "OUT_BOUND"
  | "EpisysDB";

export interface ImportedService {
  serviceGroup: string;
  svcType?: ImportedServiceType;
  services: ServiceObj[];
}

export enum ServiceType {
  NONE = "NONE",
  POWERON = "POWERON",
  LOCAL = "LOCAL",
  IN_BOUND = "IN_BOUND",
  OUT_BOUND = "OUT_BOUND",
}

export interface ServiceObj {
  name: string;
  respFormat?: ServiceResponseType;
  respDataFormat?: ServiceResponseType;
  listKey?: string;
  listName?: string;
  serviceURL?: string;
  serviceContexts?: { [key: string]: ServiceContexts };
}

export enum ServiceResponseType {
  FLAT = "FLAT",
  LIST = "LIST",
}

export interface ServiceContexts {
  rqMapping: ServiceMapping;
  rsMapping: ServiceMapping;
  preHandler?: string;
  postHandler?: string;
}

export interface ServiceMapping {
  view: { [key: string]: string };
  ctx: { [key: string]: string };
  env: { [key: string]: string };
  signerParties?: SignerParty[];
  indexFields?: any[];
}

export interface OnHandler {
  customHandler: string;
  services: OnHandlerService[];
}

export interface OnHandlerService {
  actionType?: string;
  serviceGroup: string;
  service: string;
  name?: string;
}

export interface FormProperties {
  appName: string;
  appDisplayName: string;
  appDecription: string;
  addBorderToInputs: boolean;
  autoPrint: boolean;
  disableShareLoanLoanAppPopup: boolean;
  imagingDocName: string;
  imagingDocType: string;
  emailTemplate: string;
  defaultFont: string;
  logo?: Logos;
  barcode: Barcode;
  imagingIndex: ImagingIndex;
  printSetting: PrintSetting;
}

export enum ResponseStatus {
  success = "S",
  failed = "F",
  warning = "W",
}

export enum ViewType {
  main = "MAIN",
  popup = "POPUP",
}

export enum AppFieldType {
  none = "NONE",
  LABEL = "LABEL",
  TEXT = "TEXT",
  COMOBOX = "COMOBOX",
  RADIOBTN = "RADIOBTN",
  TEXTAREA = "TEXTAREA",
  CHECKBOX = "CHECKBOX",
  SIGNATURE = "SIGNATURE",
  PUSHBTN = "PUSHBTN",
  IMAGE = "IMAGE",
  ANCHOR = "ANCHOR",
  BUTTON = "BUTTON",
  HR = "HR",
  RADIO = "RADIO",
}

export enum TriggerAction {
  SERVICE = "Service",
  FUNCTION = "Function",
  CUSTOM_LISTENER = "Custom Listener",
  TRIGGER = "Trigger",
}

export interface RadioChoice {
  id: number;
  selected: boolean;
  name: string;
}
